import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  styled,
  Stack,
  Divider,
  Button,
  Avatar,
} from "@mui/material";
import { useApi } from "../store/UserLoginContext";

const StyledTableCell = styled(TableCell)({
  border: "1px solid black",
  padding: "2px",
  textAlign: "center",
  textAlign: "left",
  paddingLeft: "5px",
  fontSize: "12px",
});

const NewForm = (props, ref) => {
  return(
    <Box
    ref={ref}
    sx={{
      width: "276mm",
      minHeight: "180mm",
      // padding: "1mm",
      bgcolor: "#fff",
      color: "#000",
      fontSize: "13px", // slightly reduced
      lineHeight: 1.6,
      fontFamily: "serif",
      mb: "6mm",
    }}
    >
      <style>
        {`@media print {
          @page {
          size: A4 landscape;
          margin: 10mm;
          }
        }`}
      </style>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box width="100%" bgcolor="grey.100" p={1.5}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mb={0}
          >
            <Grid item mt={0}>
              <img
                src="\img\vpm_gns_logo.png"
                width={100}
                height={70}
                alt="School Logo"
              />
            </Grid>
            <Grid item xs textAlign="center" mr={8}>
              <Typography
                fontWeight="bold"
                textTransform="uppercase"
                fontSize={"2.2em"}
                sx={{ fontFamily: "Alien Invader" }}
              >
                V.P.M Gyan Niketan School
              </Typography>
              <Typography variant="body1" mt={0} fontWeight="bold">
                BAIRIA, P.O. SUDNA, P.S DALTONGANJ, PALAMU, JH
              </Typography>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={"center"}
            borderBottom={4}
            borderColor="black"
            py={1}
            mb={1}
          />
          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems={"center"}
            border={"2px solid black"}
            borderColor="black"
            py={1}
            mb={2}
            width={"100%"}
          >
            <Typography variant="h6" fontWeight={"bold"}>
              Ward Category Report for Class {props[0]?.class_name} - {props[0]?.section_name}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Table for Ward Category Report */}
      <Box style={{margin: "2.5mm"}}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <strong>Name</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Roll no.</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Class</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Section</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Ward Category</strong>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.map((item, index) => (
                <TableRow key={index}>
                  <StyledTableCell>{item.name}</StyledTableCell>
                  <StyledTableCell>{item.roll_number}</StyledTableCell>
                  <StyledTableCell>{item.class_name}</StyledTableCell>
                  <StyledTableCell>{item.section_name}</StyledTableCell>
                  <StyledTableCell>{item.admission_catagory}</StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}


const WardCategoryReportTemplate = React.forwardRef(({data}, ref) => {
  const { currentSessionAY } = useApi();

  return <div ref={ref}>{NewForm(data, ref)}</div>;
});

export default WardCategoryReportTemplate;